import { useSelector } from 'react-redux';
import { selectTitleCheckError, selectTitleCheckLoadingState, selectTitleCheckResponse } from '../../redux-state/selectors';

function TitleOutputRightSide() {
  const titleCheckResponse = useSelector(selectTitleCheckResponse);
  const isLoading = useSelector(selectTitleCheckLoadingState);
  const error = useSelector(selectTitleCheckError);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }
  if (!titleCheckResponse) {
    return <div>No data available</div>;
  }

  const { vehicle_interests_section, title_info, brand_info } = titleCheckResponse;

  return (
    <div className="flex flex-col w-[100%]">
      <div className="flex flex-col w-[100%]">
        <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
          <div className="text-gray-700 mb-3 font-bold">
            Vehicle Interests
          </div>

          <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-24">
            <div className="flex flex-col w-[100%] text-gray-700 gap-2">
              {vehicle_interests_section?.title_owner &&
                <div className="flex flex-row justify-between">
                  <div>
                    Title Owner:
                  </div>
                  <div className="font-medium">
                    {vehicle_interests_section?.title_owner}
                  </div>
                </div>
              }

              {vehicle_interests_section?.title_owner_address &&
                <div className="flex flex-row justify-between">
                  <div>
                    Title Owner Address:
                  </div>
                  <div className="font-medium">
                    {vehicle_interests_section?.title_owner_address}
                  </div>
                </div>
              }

              {vehicle_interests_section?.has_lien_holder &&
                <div className="flex flex-row justify-between">
                  <div>
                    Has Lienholder:
                  </div>
                  <div className="font-medium">
                    {vehicle_interests_section?.has_lien_holder ? 'True' : 'False'}
                  </div>
                </div>
              }

              {vehicle_interests_section?.lien_date &&
                <div className="flex flex-row justify-between">
                  <div>
                    Lien Date:
                  </div>
                  <div className="font-medium">
                    {vehicle_interests_section?.lien_date}
                  </div>
                </div>
              }

              {vehicle_interests_section?.lien_holder_name &&
                <div className="flex flex-row justify-between">
                  <div>
                    Lienholder Name:
                  </div>
                  <div className="font-medium">
                    {vehicle_interests_section?.lien_holder_name}
                  </div>
                </div>
              }

              {vehicle_interests_section?.lien_holder_address &&
                <div className="flex flex-row justify-between">
                  <div>
                    Lienholder Address:
                  </div>
                  <div className="font-medium">
                    {vehicle_interests_section?.lien_holder_address}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
          <div className="text-gray-700 mb-3 font-bold">
            Current Title Information
          </div>

          <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-24">
            <div className="flex flex-col w-[100%] text-gray-700 gap-2">
              {title_info?.title_number &&
                <div className="flex flex-row justify-between">
                  <div>
                    Title Number:
                  </div>
                  <div className="font-medium">{title_info?.title_number}</div>
                </div>
              }

              {title_info?.has_brands &&
                <div className="flex flex-row justify-between">
                  <div>
                    Brands Check:
                  </div>
                  <div className="font-medium">{title_info?.has_brands}</div>
                </div>
              }

              {title_info?.title_issue_date &&
                <div className="flex flex-row justify-between">
                  <div>
                    Title Issues Date:
                  </div>
                  <div className="font-medium">{title_info?.title_issue_date}</div>
                </div>
              }
            </div>
          </div>
        </div>

        {brand_info && brand_info.length > 0 &&
          <div className="bg-white p-6 text-sm border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Brand Reports
            </div>

            <div className="flex flex-col w-full gap-6 lg:gap-24 mb-6">
              <div className="flex flex-col w-[100%] text-gray-700 gap-2">
                {brand_info && brand_info.length > 0 ? (
                  brand_info.map((brand, index) => (
                    <div key={index}>
                      {brand?.re_state &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Reporting State:
                          </div>
                          <div className="font-medium">{brand?.re_state}</div>
                        </div>
                      }

                      {brand?.branding &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Branding:
                          </div>
                          <div className="font-medium">{brand?.branding}</div>
                        </div>
                      }

                      {brand?.branding_date &&
                        <div className="flex flex-row justify-between">
                          <div>
                            Branding Date:
                          </div>
                          <div className="font-medium">{brand?.branding_date}</div>
                        </div>
                      }

                      {index < brand_info.length - 1 && (
                        <div className="border-t-2 border-t-gray-100 my-4"></div>
                      )}
                    </div>
                  ))
                ) : (
                  <div>No Brands Report Available</div>
                )}
              </div>
            </div>
          </div>
          }
      </div>
    </div>
  );
}

export default TitleOutputRightSide;
